'use client';

const StepVideoPlayer = ({ videoSrc }: { videoSrc: string }) => {
  return (
    <div className="relative w-full rounded-2xl overflow-hidden bg-gradient-to-br from-green-200 via-amber-100 to-violet-200 dark:from-green-800/40 dark:via-amber-700/30 dark:to-violet-800/40 p-2 sm:p-3 lg:p-3.5">
      <div className="relative w-full rounded-xl overflow-hidden">
        <video
          src={videoSrc}
          autoPlay
          loop
          muted
          playsInline
          className="w-full h-auto block rounded-xl sm:rounded-2xl"
        />
      </div>
    </div>
  );
};

export default StepVideoPlayer;
